import * as React from 'react';
import { useEffect } from "react";
import Button from '@mui/material/Button';
import {styled} from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import MuiInput from '@mui/material/Input';
import {DemoItem} from '@mui/x-date-pickers/internals/demo';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

const Input = styled(MuiInput)`
  width: 100px;
`;

const drawerBleeding = 56;

interface Props {
  window?: () => Window;
}

export default function SwipeableEdgeDrawer(props: any) {
  const { window } = props;
  const [open, setOpen] = React.useState(false);
  const [high, setHigh] = React.useState(props.targetPressure.bloodPressureHigh);
  const [low, setLow] = React.useState(props.targetPressure.bloodPressureLow);

  
  useEffect(() => {
    setHigh(props.targetPressure.bloodPressureHigh);
    setLow(props.targetPressure.bloodPressureLow);
  }, [props]);
  
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const container = window !== undefined ? () => window().document.body : undefined;

  function handleClickSave(){
    setOpen(false);
    props.savePressure({high: high, low: low});
  }
  
  function handleChangeHigh(value: any){
    setHigh(value);
  }
  
  function handleChangeLow(value: any){
    setLow(value);
  }
  
  return (

    <Box>
      <Grid container justifyContent="center" alignItems="center" sx={{ width: "100%" }}>
        <Stack sx={editbtn} >
          <EditButton onClick={toggleDrawer(true)}>입력 하기</EditButton>
        </Stack>
      </Grid>

      <SwipeableDrawer
        container={container}
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={true}
        ModalProps={{
          keepMounted: false,
        }}
        sx={{ '& .MuiDrawer-paper': { borderRadius: '20px 20px 0 0' } }}
      >
        <Box sx={{ m: 0, py: 3, px: 2 }}>
          <Stack >
            <Typography
              sx={{
                color: '#333',
                fontSize: 18,
                fontWeight: 700,
                textAlign: 'center',
                mb: '20px',
                borderBottom: '1px solid #ddd',
                pb: 2
              }}
            >
              오늘의 혈압을 입력하세요
            </Typography>
          </Stack>
          {/*<Stack direction={'row'} spacing={2} sx={{ '& .MuiTextField-root': { minWidth: 'auto !important' }, '& .MuiOutlinedInput-input': { textAlign: 'center' } }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DateField']} sx={{ flex: 1, border: 0, '& .MuiOutlinedInput-notchedOutline': { border: 0 } }}>
                오늘날짜
                <DemoItem label="날짜">
                  <DateField
                    defaultValue={dayjs('2024-10-17')}
                    format="YYYY-MM-DD"
                    disabled
                    sx={{ border: 0, '& .MuiOutlinedInput-input.Mui-disabled': { '-webkitTextFillColor': '#333' } }}
                  />
                </DemoItem>
              </DemoContainer>

              <DemoContainer components={['MobileTimePicker']} sx={{ flex: 1, }}>
                <DemoItem label="시간">
                  <MobileTimePicker defaultValue={dayjs('2022-04-17T15:30')} sx={{ bgcolor: '#fff' }} />
                </DemoItem>
              </DemoContainer>
            </LocalizationProvider>
          </Stack>*/}

          <Stack direction={'row'} spacing={2} mt={0} sx={{ width: '100%', '& .MuiOutlinedInput-input': {  bgcolor: '#fff', textAlign: 'center', py:1 } }}>
            <DemoItem label="수축기(mmHg)" sx={{ flex: 1 }}>
              <TextField
                type="number"
                placeholder='수축기 입력'
                defaultValue={props.targetPressure.bloodPressureHigh}
                onChange={(e) => { handleChangeHigh(e.target.value) }}
              />
            </DemoItem>
            <DemoItem label="이완기(mmHg)" sx={{ flex: 1 }}>
              <TextField
                type="number"
                placeholder='이완기 입력'
                defaultValue={props.targetPressure.bloodPressureLow}
                onChange={(e) => { handleChangeLow(e.target.value) }}
              />
            </DemoItem>
          </Stack>

          <Stack sx={{ p: 0, width: '100%', boxSizing: 'border-box',}}>
            <Button onClick={handleClickSave} sx={bottomBtn}>
              저장
            </Button>
          </Stack>

        </Box>
      </SwipeableDrawer>
    </Box>
  );
}

const editbtn = {
  width: '49%',
  alignItems: 'center'
}

const EditButton = styled(Button)({
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '6px 20px',
  lineHeight: 1.5,
  backgroundColor: '#fff',
  border: '1px solid #EF8322',
  borderRadius: '20px',
  color: '#EF8322',
  margin: '10px 0 30px 0',
  width: '90%',

  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
  },
  '&:focus': {
    boxShadow: 'none',
  },
});


const bottomBtn = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: 16,
  fontWeight: 700,
  padding: '10px 20px',
  lineHeight: 1.5,
  backgroundColor: '#EF8322',
  color: '#fff',
  width: '100%',
  borderRadius: '20px',
  mt: 3,
  '&:hover': {
    backgroundColor: '#EF8322',
    borderColor: '#EF8322',
    boxShadow: 'none',
    color: '#fff'
  },
}
